import { render, staticRenderFns } from "./DialogOptInWhatsapp.vue?vue&type=template&id=1a25c612&scoped=true"
import script from "./DialogOptInWhatsapp.vue?vue&type=script&lang=js"
export * from "./DialogOptInWhatsapp.vue?vue&type=script&lang=js"
import style0 from "./DialogOptInWhatsapp.vue?vue&type=style&index=0&id=1a25c612&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a25c612",
  null
  
)

export default component.exports